export const CHANGE_PARAMETRE = 'CHANGE_PARAMETRE';
export const CREATE_GRILLE = 'CREATE_GRILLE';
export const ADD_SOMME = 'ADD_SOMME';
export const ADD_TOTAL = 'ADD_TOTAL';
export const SET_VISIBILITY_CORRECTION = 'SET_VISIBILITY_CORRECTION';
export const SET_FOCUS = 'SET_FOCUS';
